import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { trackPixelEvent } from '../hooks/useMetaPixel';
const trust = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: CreditCardIcon,
  label: 'Tarjeta de débito o crédito'
}];
export function FinalCta() {
  return <section className="w-full border-t border-ink-800 bg-ink-900 py-20" id="checkout" aria-labelledby="cierre" style={{
    paddingTop: "37px",
    paddingBottom: "37px"
  }} data-id="element-68" data-mp="1jasbgor24ng9">
      <div className="mx-auto w-full max-w-4xl px-4 text-center sm:px-6" data-id="element-69" data-mp="1t253bgcuvdma">
        <h2 id="cierre" className="font-display text-3xl font-900 leading-tight text-white sm:text-[2.75rem]" data-id="element-70" data-mp="1o4wjzcfz13jg">
          El sol ya está ahí. Gratis. Todos los días.
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-relaxed text-slate-300" data-id="element-71" data-mp="1x51q7j9fhvw1">
          La única decisión que falta es si vas a aprovecharlo con información real o si vas a
          seguir regalándole ese dinero a tu compañía eléctrica otro mes más.
        </p>
        <p className="mx-auto mt-4 max-w-2xl font-display text-lg font-700 text-gold" data-id="element-72" data-mp="s6ij559k50jf">
          Más de 1.200 familias en España y Latinoamérica ya tomaron esa decisión. Hoy es tu turno.
        </p>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-73" data-mp="120ion88r47so">
          <Countdown label="El precio cierra en" data-id="element-74" data-mp="163f6uxudq1w3" />
        </div>

        <div className="mt-8 flex justify-center" data-id="element-75" data-mp="1b3a2fep3nfnh">
          <a href="https://codigo-solar-360.impultienda.ar/checkout" onClick={() => trackPixelEvent('InitiateCheckout', {
          value: 17,
          currency: 'USD'
        })} className="rounded-xl bg-gold px-8 py-4 font-display text-base font-800 uppercase tracking-wide text-ink-950 transition-[transform,background-color] duration-150 ease-smooth hover:bg-gold-400 active:scale-[0.985] sm:text-lg" style={{
          fontSize: "20px"
        }} data-id="element-76" data-mp="1b1ytz1kpljq1">
            OBTENER ACCESO AL CÓDIGO SOLAR SOLO POR — $14 USD
          </a>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-2 text-[13px] text-slate-400" data-id="element-77" data-mp="3lvudzrh8j348">
          {trust.map(item => <li key={item.label} className="flex items-center gap-1.5" data-id="element-78" data-mp="3huvkv13klib">
              <item.icon className="h-3.5 w-3.5 text-leaf-400" aria-hidden="true" data-id="element-79" data-mp="3uwitkqma1bj8" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </section>;
}